import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogActions, DialogContent, Divider, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomButton from "../Common/CustomButton";
import { TagsInputUniqueKeys } from "../Common/TagInputsUniqueKeys";

export default function UploadCNFilter({
  open,
  onClose,
  setAppliedFilters,
  appliedFilters,
  grnNumberOptions = [],
  invoiceNumberOptions = [],
  warehouseNameOptions = [],
}: {
  open: boolean;
  onClose: () => void;
  setAppliedFilters: React.Dispatch<React.SetStateAction<Record<string, string[]>>>;
  appliedFilters: Record<string, string[]>;
  grnNumberOptions?: { grnNumber: string }[];
  invoiceNumberOptions?: { invoiceNumber: string }[];
  warehouseNameOptions?: { warehouseName: string }[];
}) {
  const [GRNNumbers, setGRNNumbers] = useState<string[]>(appliedFilters.grnNumber || []);
  const [invoiceNumbers, setInvoiceNumbers] = useState<string[]>(appliedFilters.invoiceNumber || []);
  const [warehouseName, setWarehouseName] = useState<string[]>(appliedFilters.warehouseName || []);

  const handleApplyFilter = () => {
    setAppliedFilters({
      grnNumber: GRNNumbers.filter((v) => v.trim() !== ""),
      invoiceNumber: invoiceNumbers.filter((v) => v.trim() !== ""),
      warehouseName: warehouseName.filter((v) => v.trim() !== ""),
    });
    onClose();
  };

  const handleClearFilters = () => {
    setAppliedFilters({
      grnNumber: [],
      invoiceNumber: [],
      warehouseName: [],
    });
    onClose();
  };

  return (
    <Dialog open={open} sx={{ "& .MuiDialog-paper": { borderRadius: "4px", minWidth: "700px" } }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px" }}>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Apply Filter
        </Typography>
        <IconButton aria-label="close" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 16px",
            }}
          >
            <Typography variant="subtitle2">GRN Number</Typography>
            <Box sx={{ width: "400px" }}>
              <TagsInputUniqueKeys
                tags={GRNNumbers}
                setTags={setGRNNumbers}
                fullWidth={true}
                placeholder="Newline separated GRN Numbers"
                splitter="newline"
                limitTags={1}
                textFieldProps={{ multiline: true, maxRows: 1 }}
                options={grnNumberOptions}
                accessor={"grnNumber"}
                uniqueKeyAccessor={"grnNumber"}
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 16px",
            }}
          >
            <Typography variant="subtitle2">Invoice Numbers</Typography>
            <Box sx={{ width: "400px" }}>
              <TagsInputUniqueKeys
                tags={invoiceNumbers}
                setTags={setInvoiceNumbers}
                fullWidth={true}
                placeholder="Newline separated Invoice Numbers"
                splitter="newline"
                limitTags={1}
                textFieldProps={{ multiline: true, maxRows: 1 }}
                options={invoiceNumberOptions}
                accessor={"invoiceNumber"}
                uniqueKeyAccessor={"invoiceNumber"}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 16px",
            }}
          >
            <Typography variant="subtitle2">Warehouse Name</Typography>
            <Box sx={{ width: "400px" }}>
              <TagsInputUniqueKeys
                tags={warehouseName}
                setTags={setWarehouseName}
                fullWidth={true}
                placeholder="Newline separated Warehouse Name"
                splitter="newline"
                limitTags={1}
                textFieldProps={{ multiline: true, maxRows: 1 }}
                options={warehouseNameOptions}
                accessor={"warehouseName"}
                uniqueKeyAccessor={"warehouseName"}
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <CustomButton
          onClick={() => {
            handleClearFilters();
          }}
          variant="text"
        >
          Clear Filter
        </CustomButton>
        <CustomButton
          variant="contained"
          onClick={() => {
            handleApplyFilter();
          }}
        >
          Apply
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}
